import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";

export class ConferenceStore {
    audioEnabled: boolean = false;
    videoEnabled: boolean = false;
    videoListMinimized: boolean = false;
    windowWidth = window.innerWidth;
    windowHeight = window.innerHeight;
    roomId: string = "";
    videoRecordStatus: string = "";
    videoToken: string = "";

    rootStore: IRootStore;
    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);

        this.rootStore = rootStore;
    }

    setVideoToken = (token: string) => {
        this.videoToken = token;
    }
    get getVideoToken() {
        return this.videoToken;
    }

    setVideoRecordStatus = (status: string) => {
        this.videoRecordStatus = status;
    }
    get getVideoRecordStatus() {
        return this.videoRecordStatus;
    }

    setRoomId = (roomId: string) => {
        this.roomId = roomId;
    }
    get getRoomId() {
        return this.roomId;
    }

    updateWindowRize = (winWidth: number, winHeight: number) => {
        this.windowWidth = winWidth;
        this.windowHeight = winHeight;
    }
    get getWindowWidth() {
        return this.windowWidth;
    }
    get getWindowHeight() {
        return this.windowHeight;
    }

    toggleAudioEnabled() {
        this.audioEnabled = !this.audioEnabled;
    }
    toggleVideoEnabled() {
        this.videoEnabled = !this.videoEnabled;
      }
    toggleVideoListMinimized() {
    this.videoListMinimized = !this.videoListMinimized;
    }
    get getAudioStatus() {
        return this.audioEnabled;
    }
    get getVideoStatus() {
        return this.videoEnabled;
    }
    get getVideoListMinimizeStatus() {
        return this.videoListMinimized;
    }
}